/**
 * PostPaymentWelcomeModal - Welcome message shown after successful payment
 *
 * Simple welcome modal that shows after subscription payment is complete
 * Customizable message and button text via config
 */

import { POST_PAYMENT_WELCOME_MESSAGE, WELCOME_SIGNATURE } from '@/config/brandConfig'
import { Modal } from '@/components/ui/Modal'

interface PostPaymentWelcomeModalProps {
  isOpen: boolean
  onContinue: () => void
}

// Configuration - Easy to modify
export const postPaymentWelcomeConfig = {
  title: 'Welcome',
  message: POST_PAYMENT_WELCOME_MESSAGE,
  signature: WELCOME_SIGNATURE,
  signatureStyle: {
    fontFamily: 'Caveat, cursive',
    fontSize: '2.5rem',
    fontWeight: 400
  },
  buttonText: 'Enter'
}

export function PostPaymentWelcomeModal({ isOpen, onContinue }: PostPaymentWelcomeModalProps) {
  // Prevent closing modal (no-op function)
  const preventClose = () => {
    // Modal cannot be closed - user must click button
  }

  return (
    <Modal isOpen={isOpen} onClose={preventClose} showCloseButton={false} maxWidth="max-w-lg">
      <div className="space-y-6">
        {/* Greeting Header */}
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {postPaymentWelcomeConfig.title}
          </h2>
          <p className="text-gray-700 leading-relaxed whitespace-pre-line">
            {postPaymentWelcomeConfig.message}
          </p>
        </div>

        {/* Enter Button */}
        <button
          onClick={onContinue}
          className="w-full py-3 bg-gradient-to-r from-[#3B8DB3] to-[#6CB4D9] text-white rounded-lg font-medium shadow-sm hover:from-[#2C7799] hover:to-[#4AA3CC] transition-colors"
        >
          {postPaymentWelcomeConfig.buttonText}
        </button>
      </div>
    </Modal>
  )
}
